module.exports = __webpack_public_path__ + "static/media/16UNODC3.5feb810f.jpg";